// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import { AccountItem } from "../../../manager/DefineInterface";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryCityInfoLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelEraningHint: cc.Label = null;

	@property({ type: cc.Button, displayName:'' })
	btnExitOfficer: cc.Button = null;

	@property({ type: cc.Button, displayName:'' })
	btnJoinOfficer: cc.Button = null;

	@property({ type: cc.Label, displayName:'' })
	labelGrrisonHint: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeDropBuy: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeInfo: cc.Node = null;

    @property(BaseStateSprite)
    sprBgState: BaseStateSprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelDropBuy: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelBuy: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGrrisonAdd: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelGrrison: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGrrison: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBuyPrice: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGoodsCount: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprGoods: cc.Sprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeOwnMenu: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeNotOwnMenu: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelCityName: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelOfficerName: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	sprDropFlag: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	sprExclusiveFlag: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHead: cc.Sprite = null;

	@property({ type: cc.Node, displayName:'' })
	nodeOfficer: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeNoOfficer: cc.Node = null;

    private csvInfo: any = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        let cityId = this._carryData.cityId;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CITY, cityId);
        this.labelTitle.string = this.csvInfo.name;

        this.initLayer();
    }

    initLayer() {
        this.refreshCityState();
    }

    refreshCityState() {
        let cityId = this._carryData.cityId;

        let militaryCityDataManage = UserDataManage.instance.militaryCityDataManage;
        let militaryCityData = militaryCityDataManage.militaryCityData;
        let cityData = militaryCityData.lists.get(cityId);
        if (cityData) {
            // cityData.bDrop = true;
            // militaryCityData.saveLocalData();
            if (cityData.bDrop) {
                this.showDropState();
                this.refreshCenterInfoPos(true);
                this.showOfficerInfo(cityData.officerId);
            } else {
                this.showOwnState();
                this.refreshCenterInfoPos(false);
                this.showOfficerInfo(cityData.officerId);
            }
        } else {
            this.refreshCenterInfoPos(false);
            this.showNotBuyState();
        }
    }

    refreshCenterInfoPos(bDrop: boolean) {
        this.nodeInfo.y = bDrop ? 0 : -51.674;
    }

    showNotBuyState() {
        this.btnJoinOfficer.interactable = false;
        this.btnExitOfficer.interactable = false;

        this.setBgState(false);
        this.nodeNoOfficer.active = true;
        this.nodeOfficer.active = false;

        this.nodeNotOwnMenu.active = true;
        this.nodeOwnMenu.active = false;
        this.sprDropFlag.active = false;

        this.nodeBuyPrice.active = true;
        this.nodeGrrison.active = false;
        this.nodeDropBuy.active = false;

        let price = Number(this.csvInfo.price);
        this.labelBuy.string = data_control.getNumberFormat(price);

        this.showEarningInfo(null, false)
    }

    showOwnState() {
        this.btnJoinOfficer.interactable = true;
        this.btnExitOfficer.interactable = true;
        this.setBgState(false);
        this.sprDropFlag.active = false;
        this.nodeDropBuy.active = false;

        this.nodeNotOwnMenu.active = false;
        this.nodeOwnMenu.active = true;
        
        this.nodeBuyPrice.active = false;
    }

    showDropState() {
        this.btnJoinOfficer.interactable = false;
        this.btnExitOfficer.interactable = false;
        this.sprDropFlag.active = true;
        this.nodeDropBuy.active = true;

        this.nodeNotOwnMenu.active = true;
        this.nodeOwnMenu.active = false;

        this.nodeBuyPrice.active = false;

        this.setBgState(true);

        let price = Number(this.csvInfo.price);
        this.labelDropBuy.string = data_control.getNumberFormat(price);
    }

    setBgState(bFll: boolean) {
        this.sprBgState.setFill(bFll);
        this.sprBgState.node.children.forEach((v)=> {
            v.getComponent(cc.Widget).updateAlignment();
        });
    }

    showOfficerInfo(officerId: string) {
        this.sprExclusiveFlag.active = false;
        if (!utilsModel.isValidNumberValue(officerId)) {
            this.nodeGrrison.active = false;
            this.nodeOfficer.active = false;
            this.nodeNoOfficer.active = true;
            this.showEarningInfo(null, false);
            return;
        }
        this.nodeOfficer.active = true;
        this.nodeNoOfficer.active = false;

        let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.OFFICER, officerId);
        if (!csvInfo) {
			console.error('未找到武将数据 officerId = ', officerId);
            return;
		}

        this.nodeGrrison.active = true;
        
        let cityId = this._carryData.cityId;
        let bExclusive = csvInfo.exclusive_city == cityId;
        this.sprExclusiveFlag.active = bExclusive;

        this.showGarrisonInfo(officerId, csvInfo, bExclusive);
        this.showEarningInfo(csvInfo, bExclusive);
        
        this.labelOfficerName.string = csvInfo.name;
        this.refreshHead(csvInfo.icon);
        this.refreshExclusiveCity(csvInfo.exclusive_city);
    }

    showGarrisonInfo(officerId: string, csvInfo: any, bExclusive: boolean) {
        let retGarrison = bExclusive ? Number(csvInfo.exclusive_garrison) : Number(csvInfo.garrison);
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryCityData = militaryOfficerDataManage.militaryOfficerData.lists.get(officerId);
        let addGarrison = 0;
        if (militaryCityData) {
            addGarrison = militaryCityData.addGarrison * 100;
        }
        retGarrison *= 100;
        let strGarrison = retGarrison.toFixed(1) + (addGarrison>0 ? '(' : '');
        this.labelGrrison.string = strGarrison;
        this.labelGrrisonAdd.string = addGarrison>0 ? '+' + addGarrison.toFixed(1) : '';
        this.labelGrrisonHint.string = (addGarrison>0 ? ')%' : '%');
        utilsView.refreshLabelUI(this.labelGrrisonAdd);
        utilsView.refreshLabelUI(this.labelGrrisonHint);
        utilsView.refreshLabelUI(this.labelGrrison);

    }

    showEarningInfo(csvInfo: any, bExclusive: boolean) {
        let retEaring = 0;
        if (csvInfo) {
            retEaring = bExclusive ? Number(csvInfo.exclusive_eraning_promote) : Number(csvInfo.eraning_promote);
        }
        let eraning_hz = this.csvInfo.eraning_hz;
        let day_eraning = Number(this.csvInfo.day_eraning);
        day_eraning = Math.floor(day_eraning * (1+retEaring));
        this.labelEraningHint.string = `每${eraning_hz}日可获得进贡`;
        this.labelGoodsCount.string = "×" + data_control.getNumberFormat(day_eraning);
        utilsView.refreshLabelUI(this.labelEraningHint);
        this.showGoods();
    }

    async showGoods() {
        let goodsId = this.csvInfo.day_eraning_goods;
        let goodsConfig = backPackEventMap()[goodsId];
        let spPath = goodsConfig.spPath;
        let sprGoods = this.sprGoods;
        let gwidth = sprGoods.node.width * sprGoods.node.scaleX;
        let gheight = sprGoods.node.height * sprGoods.node.scaleY;
        sprGoods.node.active = false;
        let iconPath = "backpackAssets/objSp/" + spPath;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
        bundle.load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    sprGoods.node.active = true;
                    sprGoods.spriteFrame = imgs;

                    let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                    sprGoods.node.scale = scale;    
                }
            }
        );
    }

    refreshExclusiveCity(exclusive_city: string) {
		let cityCsv = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CITY, exclusive_city);
		if (!cityCsv) {
			this.labelCityName.string = '';
			console.error('未找到城池数据 exclusive_city = ', exclusive_city);
			return;
		}

		this.labelCityName.string = cityCsv.name;
	}

    refreshHead(icon: string) {
		this.sprHead.node.active = false;
        if (utilsModel.isValidNumberValue(icon)) {
            let iconPath = "res/recruit/head/" + icon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.militaryBundle).load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.sprHead.node.active = true;
                        this.sprHead.spriteFrame = imgs;
                    }
                }
            );
        }
	}

    buySuccess() {
        let cityId = this._carryData.cityId;
        let militaryCityDataManage = UserDataManage.instance.militaryCityDataManage;
        let militaryCityData = militaryCityDataManage.militaryCityData;
        let cityData = militaryCityData.lists.get(cityId);

        if (!militaryCityData.bFirstBuy) {
            militaryCityData.bFirstBuy = true;
            NormalGameManager._instance.writeGameData();
            NormalGameManager._instance.addOneWeChatTriggerLinkUnShift(GeneralKind.TriggerChatId.FIRST_BUY_CITY);
        }

        if (cityData) {
            cityData.bDrop = false;

            if (utilsModel.isValidNumberValue(cityData.officerId)) {
                let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
                let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
                let officerData = militaryOfficerData.lists.get(cityData.officerId);
                if (officerData && officerData.bDrop) {
                    militaryOfficerData.lists.delete(cityData.officerId);
                    militaryOfficerData.saveLocalData();
                }
            }
            cityData.officerId = '';
        } else {
            cityData = militaryCityData.createItem(cityId);
        }
        // let curTime = Date.now();
        let curTime = NormalGameManager._instance.getCurrentDay();
        militaryCityData.saveLocalData();
        cityData.lastDropTime = curTime;
        cityData.lastRecvAwardTime = curTime;

        this._carryData.parent.refreshState();
        this.refreshCityState();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    onClickSelectOfficer() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitarySelectOfficerLayer
            , null
            , {
                parent: this
                , cityId: this._carryData.cityId
            }
        );
    }

    /**
     * 分期支付
     */
    onClickStagesPay() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let price = data_control.getNumberFormat(Number(this.csvInfo.stages_first_repayment));
        let day = this.csvInfo.stages_day;
        let every_day_repayment = data_control.getNumberFormat(Number(this.csvInfo.every_day_repayment));
        let strHint = '首付' +  price + ',分期'+ day
            + '天, 每日还款' + every_day_repayment;
        ModelDialogLayer.show(strHint, null, this.stagesPay.bind(this));
    }

    stagesPay() {
        let price = Number(this.csvInfo.stages_first_repayment);
        let stages_day = Number(this.csvInfo.stages_day);
        let every_day_repayment = Number(this.csvInfo.every_day_repayment);
        if ( O1HD.getServices().userSrv.getCoins() < price) {
            O1HD.getModules().uiControlModule.showMessageBox("首付金额不足",this.node);
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins( -price, true);

        
        let accountItem:AccountItem = {
            uniqueId:NormalGameManager._instance.getGameData().userAccountInfo.length.toString(),
            title : '城贷',
            desc : `每日需还@！共计@ 总需还@`,
            paramsArray: [
                data_control.getNumberFormat(every_day_repayment)
                , stages_day+"日"
                , data_control.getNumberFormat(every_day_repayment*stages_day)
            ],
            totalFee : price,
            needPayDays : stages_day,
            hasPayDays : 0,
            everyDayPay: every_day_repayment*stages_day,
        }
        NormalGameManager._instance.setGameData({ userAccountInfo:[accountItem] },true );
        NormalGameManager._instance.setGameData({ userAccountInfoNewMsg : 1 } , false );
        this.buySuccess();
    }

    onClickBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let price = Number(this.csvInfo.price);
        if ( O1HD.getServices().userSrv.getCoins() < price) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足");
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins( -price, true);
        this.buySuccess();
    }

    onClickExitOfficer() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let cityId = this._carryData.cityId;
        let militaryCityDataManage = UserDataManage.instance.militaryCityDataManage;
        let militaryCityData = militaryCityDataManage.militaryCityData;
        let cityData = militaryCityData.lists.get(cityId);
        if (cityData) {
            if (utilsModel.isValidNumberValue(cityData.officerId)) {
                let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
                let officerData = militaryOfficerDataManage.militaryOfficerData.lists.get(cityData.officerId);
                if (officerData) {
                    officerData.curGarrisonCity = '';
                    militaryOfficerDataManage.militaryOfficerData.saveLocalData();
                }
            }
            cityData.officerId = '';
        } 
        militaryCityData.saveLocalData();
        this.refreshCityState();
    }

    // update (dt) {}
}
